import React, { useEffect, useState } from 'react';
import { useAuth } from '../DataStore/AuthContext';
import OrgProfileCard from '../components/Central/OrgProfileCard';
import ActivityLoader from '../components/Common/ActivityLoader';
import Notification from '../components/Common/Notification';
import ajaxUser from '../util/remote/ajaxUser';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import PageTitleActions from '../components/Common/PageTitle/PageTitleActions';
import ActionDropdownItem from '../components/Common/PageTitle/ActionDropdownItem';
import { useClearState } from '../DataStore/useClearState';
import functions from '../util/functions';

const ProfileSwitchPage = () => {

    const {connectedProfiles, getProfiles, } = useAuth();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const tokenInfo = functions.readUser();

    useEffect(()=>{
        getProfiles();
    }, [])

    useEffect(() => {
        if (functions.isObject(connectedProfiles)) {
            if (connectedProfiles.org_id) {
                // If a single profile is connected, redirect to dashboard
                navigate('/');
                window.location.reload();
            } 
        }
    }, [connectedProfiles, navigate]);

    const clearAllState = useClearState();


    if (!tokenInfo) {
        return <Navigate to="/login" />;
    }

    const handleLogout = ()=>{
        // Clear all states and remove token
        clearAllState();
        localStorage.removeItem('yexp@user');
        navigate('/login');
        window.location.reload();
    }


    const handleOrgClick = async(org_id) => {
        if(loading){
            return;
        }
        setLoading(true);
        const server_response = await ajaxUser.switchProfiles(org_id);
        setLoading(false);
        if(server_response.status === "OK"){
            navigate('/dashboard')
            window.location.reload();
        }

    };


    const PageActions = ()=>(<>
        
        <ActionDropdownItem iconClass="fa fa-plus" label="Create My Profile" onClick={()=>navigate('/profile-create')}/>
        <ActionDropdownItem iconClass="fa fa-sync" label="Refresh" onClick={()=>getProfiles(true)}/>
        <ActionDropdownItem iconClass="fa fa-arrow-right-from-bracket text-danger" label="Logout" onClick={handleLogout}/>
        </>)

    return (
        <div className={`app-container app-theme-white body-tabs-shadow fixed-header`}>
            <div className="app-main" style={{ display: 'flex', justifyContent: 'center' }}>
                <div
                    className="app-main__outer"
                    style={{
                        width: '60%',
                        padding: '0 20%', // Padding for left and right
                    }}
                >
                    <div className="app-main__inner">
                        {/** Header starts */}
                        <div className="sticky-page-title">
                            <div className="app-page-title">
                                <div className="page-title-wrapper d-flex align-items-center justify-content-between">
                                    {/* Left Section */}
                                    <div className="page-title-heading">
                                        <div className="page-title-icon">
                                            <i className="fa fa-globe icon-gradient bg-mean-fruit"></i>
                                        </div>
                                        <div>
                                            Select Company Profile
                                            <div className="page-title-subheading">
                                                Please request your organisation to add you to their profile using {tokenInfo.username} or create a <Link to="/profile-create">New profile</Link>.
                                            </div>
                                        </div>
                                    </div>

                                    {/* Right Section */}
                                    <div className="page-title-actions d-flex align-items-center">
                                        <PageTitleActions DropdownItems={PageActions} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/** Header ends */}

                        {/** Organization Tiles */}
                        <div className="organization-tiles" style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                            {!loading && Array.isArray(connectedProfiles) &&  connectedProfiles.map((org) => <OrgProfileCard key={org.org_id} org={org} handleOrgClick={handleOrgClick} />)}
                            {(!connectedProfiles || loading) && <ActivityLoader />}
                        </div>
                        {connectedProfiles === "404" && <Notification type="info" message="No connected company profiles were found" closable={false} />}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileSwitchPage;
